import { EnvConfig } from '@config';
import { createAsyncThunk } from '@reduxjs/toolkit';
import Client from 'services/networking/client';

const client = new Client(EnvConfig.drillx_gm_depthlog_api_url ?? '');

export const fetchOffsetById = createAsyncThunk(
  'ghostmode/fetchOffsetsById',
  async (tuwbi: string, thunkApi) => {
    try {
      return await client.get('/wellbore/' + tuwbi);
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);
